import { render, staticRenderFns } from "./CategoryPreview.vue?vue&type=template&id=67b0d76c"
import script from "./CategoryPreview.vue?vue&type=script&lang=js"
export * from "./CategoryPreview.vue?vue&type=script&lang=js"
import style0 from "./CategoryPreview.vue?vue&type=style&index=0&id=67b0d76c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports